export default __webpack_public_path__ + "static/media/trex_logo.5bb79bd0.png";